'use strict';

export default {
	TITLE: 'Employment Documents',
	SELECT_OPTION_LABEL: 'Attached to:',
	SELECT_OPTION_PLACEHOLDER: 'Select a position',
	STANDARD_UPLOAD_TITLE: 'General'
};